import { Form, Input, Radio } from "antd";
import HiddenFormItem from "../../../components/HiddenFormItem";
export default function SupplierModifier({ originForm }) {
  const [form] = Form.useForm(originForm);
  return (
    <Form
      form={form}
      initialValues={{ validity: 1 }}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 18 }}
    >
      <HiddenFormItem name="id" />
      <Form.Item
        name="supplierName"
        label="供应商名称"
        rules={[{ required: true, message: "请输入供应商名称" }]}
      >
        <Input placeholder="请输入供应商名称4-50字" />
      </Form.Item>
      <Form.Item name="companyName" label="公司名称">
        <Input placeholder="请输入公司名称4-50字" />
      </Form.Item>
      <Form.Item
        name="contactName"
        label="联系人"
        rules={[{ required: true, message: "请输入联系人名称" }]}
      >
        <Input placeholder="请输入联系人姓名" />
      </Form.Item>
      <Form.Item
        name="contactPhone"
        label="联系人电话"
        rules={[{ required: true, message: "请输入联系人电话" }]}
      >
        <Input placeholder="请输入联系人电话" />
      </Form.Item>
      <Form.Item name="validity" label="状态" required>
        <Radio.Group>
          <Radio value={1}>启用</Radio>
          <Radio value={0}>禁用</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="remark" label="备注">
        <Input.TextArea
          placeholder="请输入备注"
          autoSize={{ minRows: 4, maxRows: 10 }}
        />
      </Form.Item>
    </Form>
  );
}
